import type { ReactNode } from 'react';

type Props = {
  active?: boolean;
  onClick?: () => void;
  children: ReactNode;
};

export function Chip({ active, onClick, children }: Props) {
  return (
    <button type="button" className={`chip ${active ? 'active' : ''}`} onClick={onClick}>
      {children}
    </button>
  );
}

export function ChipRow({ children }: { children: ReactNode }) {
  return <div className="chip-row">{children}</div>;
}
